// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimatedAssetLayer_wrapper__SpZwh"};